import { essencePosts } from '@/mocks/home';
import SectionHeading from '@/pages/home/components/SectionHeading';
import Reveal from '@/components/base/Reveal';

export default function EssenceSection() {
  return (
    <section id="essence" className="w-full border-y border-background-200 bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1360px] px-4 md:px-6">
        <SectionHeading
          accent
          kicker="精华帖 · 按热度排序"
          title="精华热榜 Top 8"
          desc="精华帖不看发布时间，只看热度与资料价值。每一次排序变化，都对应着讨论区里新补上来的一条线索。"
          actionLabel="进入完整榜单"
        />

        <div className="mt-6 divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {essencePosts.map((post, index) => (
            <Reveal key={post.rank} delay={index * 50}>
              <article className="group flex items-center gap-4 px-4 py-4 transition-colors hover:bg-background-100 md:px-6 md:py-5">
                <span
                  className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-md font-heading text-lg font-bold ${
                    post.rank <= 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-500'
                  }`}
                >
                  {post.rank}
                </span>

                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="rounded bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-900">
                      {post.badge}
                    </span>
                    <span className="text-[11px] text-foreground-400">{post.time}</span>
                  </div>
                  <h3 className="mt-1.5 truncate font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                    {post.title}
                  </h3>
                  <p className="mt-1 text-xs text-foreground-500">@{post.author}</p>
                </div>

                <div className="hidden shrink-0 items-center gap-6 sm:flex">
                  <div className="text-right">
                    <p className="flex items-center justify-end gap-1 font-heading text-sm font-bold text-primary-600">
                      <i className="ri-fire-line" />
                      {post.heat}
                    </p>
                    <p className="mt-0.5 text-[11px] text-foreground-400">讨论热度</p>
                  </div>
                  <div className="text-right">
                    <p className="font-heading text-sm font-bold text-foreground-800">{post.replies}</p>
                    <p className="mt-0.5 text-[11px] text-foreground-400">条最新回复</p>
                  </div>
                </div>

                <i className="ri-arrow-right-up-line shrink-0 text-lg text-foreground-300 transition-colors group-hover:text-primary-600" />
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}